import { useMutation, useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api/client'
import type { ApiResponse } from '@/lib/api/types'
import type {
  CostSimulationRequest,
  CostSimulationResponse,
  CareRateEntry,
} from '@/types/cost'

/**
 * 비용 시뮬레이션 계산 뮤테이션.
 *
 * POST /api/v1/cost-simulator/calculate
 */
export function useCalculateCost() {
  return useMutation({
    mutationFn: async (data: CostSimulationRequest) => {
      const response = await apiClient.post<ApiResponse<CostSimulationResponse>>(
        '/cost-simulator/calculate',
        data
      )
      return response.data.data
    },
  })
}

/**
 * 수가 테이블 조회 훅.
 *
 * GET /api/v1/cost-simulator/rates
 * 24시간 캐시 (수가 데이터는 거의 변동 없음)
 */
export function useCareRates() {
  return useQuery({
    queryKey: ['careRates'],
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<CareRateEntry[]>>(
        '/cost-simulator/rates'
      )
      return response.data.data
    },
    staleTime: 24 * 60 * 60 * 1000,
  })
}
